import {
  animate,
  motion,
  useInView,
  useMotionValue,
  useTransform,
} from "framer-motion";
import { useEffect, useRef } from "react";

const Counter = ({ from, to }) => {
  const count = useMotionValue(from);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const ref = useRef(null);
  const isInView = useInView(ref);

  useEffect(() => {
    if (isInView) {
      const animation = animate(count, to, { duration: 3, delay: 0.5 });
      return () => animation.stop;
    } else {
      // return () => animation.stop;
    }
  }, [isInView, count, to]);
  return (
    <div ref={ref} className="text-center">
      <div className="flex items-center justify-center gap-0 text-4xl font-bold text-visOrange md:text-6xl">
        <motion.p>{rounded}</motion.p>
        <p className="align-middle">+</p>
      </div>
    </div>
  );
};

export default Counter;
